export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/wasm-module.651439dd5f370a99.js");
}
